import React from 'react';
import { motion } from 'framer-motion';

const STEPS = [
  { kind: 'step', label: 'Detect', body: 'the pirate stream' },
  { kind: 'step', label: 'Send', body: 'a takedown notice' },
  { kind: 'step', label: 'Wait', body: 'for the hosting provider to respond' },
  {
    kind: 'hit',
    label: '91%',
    body: 'of providers ignore it.',
    accent: 'coral',
    source: 'Friend MTS, IBC 2025',
  },
  {
    kind: 'hit',
    label: 'Reappears',
    body: 'within 24 hours, 90% of the time.',
    accent: 'coral',
  },
  {
    kind: 'step',
    label: 'The match',
    body: (
      <>
        is already <span className="text-coral font-medium">over.</span>
      </>
    ),
  },
];

const Row = ({ item, index }) => {
  const isHit = item.kind === 'hit';
  return (
    <motion.div
      initial={{ opacity: 0, x: -24 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, margin: '-10%' }}
      transition={{ delay: 0.05 * index, duration: 0.6 }}
      className="relative grid grid-cols-12 gap-4 md:gap-8 py-6 md:py-7 items-start"
    >
      <div className="col-span-2 md:col-span-1 flex items-start pt-2">
        <span className="font-mono text-[0.7rem] uppercase tracking-[0.35em] text-white/30">
          {String(index + 1).padStart(2, '0')}
        </span>
      </div>

      <div className="col-span-10 md:col-span-11">
        <div className="flex items-baseline gap-4 md:gap-6 flex-wrap">
          <span
            className={`font-display font-bold tracking-tight ${
              isHit ? 'text-coral' : 'text-white'
            }`}
            style={{ fontSize: 'clamp(1.5rem, 4vw, 3.25rem)' }}
          >
            {item.label}
          </span>
          <span
            className={`font-display font-light ${
              isHit ? 'text-white' : 'text-white/60'
            }`}
            style={{ fontSize: 'clamp(1.1rem, 2.4vw, 2rem)' }}
          >
            {item.body}
          </span>
        </div>
        {item.source && (
          <p className="text-mist-500 font-mono text-xs tracking-[0.25em] uppercase mt-3">
            Source · {item.source}
          </p>
        )}
      </div>
    </motion.div>
  );
};

const Section02WhyFails = () => {
  return (
    <section className="section-pad section-glass" id="why-fails">
      <div className="container-edge">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="flex flex-col gap-6 mb-20 md:mb-28 max-w-4xl"
        >
          <h2 className="font-display font-bold text-white leading-[0.95] tracking-tight text-section">
            Chasing pirates<br />
            is the strategy.<br />
            <span className="text-teal">Here&rsquo;s how it plays out.</span>
          </h2>
        </motion.div>

        <div className="relative pl-2 md:pl-10">
          {/* vertical connecting line */}
          <div className="pointer-events-none absolute left-[13px] md:left-[calc(8.33%_-_1px)] top-4 bottom-4 w-px bg-white/10" />

          <div className="divide-y divide-white/5">
            {STEPS.map((item, i) => (
              <Row key={i} item={item} index={i} />
            ))}
          </div>
        </div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="mt-20 md:mt-28 max-w-3xl text-2xl md:text-3xl font-display font-medium text-white leading-[1.2]"
        >
          The industry has been fighting piracy by chasing pirates.{' '}
          <span className="text-teal">The data says it doesn&rsquo;t work.</span>
        </motion.p>
      </div>
    </section>
  );
};

export default Section02WhyFails;
